import React from 'react';
import { Container, Row, Col, TabContent, TabPane } from 'reactstrap';
import LoginTab from './Tabs/LoginTab';
// Muhtemelen form kütüphaneleri veya kendi state yönetiminiz için importlar vardır
// import { useForm } from 'react-hook-form';
// import { loginApi } from '../Services/AuthService'; // API çağrısını yorumlayacağız

const Signin = () => {
  // const [error, setError] = useState(null); // Hata yönetimi yorumlanabilir

  return (
    <Container fluid={true} className='p-0 login-page'>
      <Row>
        <Col xs='12'>
          <div className='login-card'>
            <div className='login-main login-tab'>
              <TabContent activeTab={'jwt'} className='content-login'>
                <TabPane className='fade show' tabId={'jwt'}>
                  <LoginTab />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Signin;
